(function()
{
	"use strict";

	function CollectionShip()
	{
		this.Container_constructor();

		this.mouseEnabled = false;
		this.ship = new cjs.Sprite(cm.Assets.lib.gameSS, "ship-collection").center();
		this.ship.regY = 220;
		this.ship.y = 110;
		this.caughtIt = false;
		this.grapple = new cjs.Sprite(cm.Assets.lib.gameSS, "grapple-"+cm.main.gameSettings.grapple).center();
		this.grapple.y = -70;
		this.grapple.rotation = -90;
		this.garbageCollector = new cjs.Container();
		this.name = "CollectionShip";
		this.addChild(this.garbageCollector, this.grapple, this.ship);
		this.createGrappleMask();
	}

	var p = createjs.extend(CollectionShip, cjs.Container);
	p.createGrappleMask = function()
	{
		var mask = new cjs.Shape(new cjs.Graphics().f("#000").r(0,0,600,600));
		mask.regY = mask.regX = 300;
		mask.alpha = 0.5;
		mask.y = -200;
		this.grapple.mask = mask;
	};

	p.setActive = function( bool )
	{
		if(bool)
		{

		}
		else
		{

		}
	};

	p.triggerGrapple = function (garbage, pt)
	{
		garbage.particle.visible = false;
		this.caughtIt = true;
		var dx = pt.x - this.grapple.x;
		var dy = pt.y - this.grapple.y;
		if(garbage.score === 0)
			cm.app.sound.play("present-collect");
		else
			cm.app.sound.play("collect-1");


		var distance = Math.distance(pt, this.grapple);
		var theta = Math.atan2(dy, dx);
		var angle = Math.toDeg(theta);
		cjs.Tween.get(this.grapple).to({rotation: angle, x:pt.x, y:pt.y+40}, 200).call(this.createParticleEmitter, [pt.x, pt.y], this).call(this.bringInGarbage, [garbage], this).to({rotation:-90},150);
	};

	p.createParticleEmitter = function (px, py) {
        // Create the display object or an array of display objects we want as the particles

        var shapes = [
			new cjs.Sprite(cm.Assets.lib.gameSS, "particle").center()
        ];
		var pt = this.localToLocal(px, py, this.parent);
        // Settings for the particle you want
        var particle = {
            shape: shapes,
            lifetime: { min: 1, max: 3 },
            speed: { min: 2, max: 4 },
            rotateSpeed: { min: 0, max: 0 },
            scale: { start: 1, end: 0.6 },
            opacity: { start: 1, end: 0 },
            force: { x: 0, y: 0 },
            gravity: { on: false, speed: 0 }
        };

        // Settings for the emitter
        var emitterSettings = {
            pos: { x: 0, y: 0 },
            particle: particle,
            count: 10,
            rate: 0,
            loop: false,
            burst: true,
            startOn: true
        };
        var particleEmitter = new cm.ParticleEmitter(emitterSettings);
		var sparkleContainer = new cjs.Container();
		sparkleContainer.x = pt.x;
		sparkleContainer.y = pt.y;
		sparkleContainer.addChild(particleEmitter);
		this.parent.addChild(sparkleContainer);
		cjs.Tween.get(this).wait(1000).call(this.parent.removeChild, [sparkleContainer], this.parent);
    };

	p.removeContainer = function(cont)
	{
		this.removeChild(cont);
	};


	p.grappleGrab = function()
	{
		if(cm.main.gameSettings.grapple < 2)
			this.grapple.gotoAndPlay("grapple-1-close");
	};

	p.grappleRelease = function()
	{

		this.grapple.gotoAndPlay("grapple-"+cm.main.gameSettings.grapple);
	};

	p.setCaughtIt = function()
	{
		this.caughtIt = false;
	};

	p.bringInGarbage = function(garbage)
	{
		this.grappleGrab();
		cjs.Tween.get(this.grapple).to({x:0, y:40}, 150).call(this.grappleRelease, null, this).to({x:0, y:-70}, 150).call(this.setCaughtIt, null, this);
		cjs.Tween.get(garbage).to({x: 0, y: 0}, 150).call(this.removeGarbage, [garbage], this);
		if(garbage.particle){
			garbage.particle.parent.removeChild(garbage.particle);
		}
	};

	p.wrongCollectable = function()
	{
		if(this.isWrong){return;}
		cm.app.sound.play("trash-hit");
		this.isWrong = true;
		cjs.Tween.get(this, {override: true})
		.call(this.switchShipColor, null, this).wait(250)
		.call(this.switchShipColor, null, this).wait(250)
		.call(this.switchShipColor, null, this).wait(250)
		.call(this.switchShipColor, null, this)
		.set({isWrong:false});
	};

	p.shipShake = function()
	{
		cjs.Tween.get(this).to({x:this.x + 25},50, cjs.Ease.quadInOut).to({x:this.x-25},50, cjs.Ease.quadInOut).to({x:this.x + 25},100, cjs.Ease.quadInOut).to({x:this.x-25},100, cjs.Ease.quadInOut).to({x:this.x + 25},150, cjs.Ease.quadInOut).to({x:this.x},150, cjs.Ease.quadInOut);
	};

	p.switchShipColor = function()
	{
		if(this.ship.currentAnimation === "ship-collection"){
			this.ship.gotoAndPlay("ship-collection-wrong");
			this.ship.center();
			this.ship.regY = 272.5;
			// this.ship.regX = 163.75;
			cjs.Tween.get(this.grapple).to({x:0, y:-70}, 150).call(this.setCaughtIt, null, this);
		} else{
			this.ship.gotoAndPlay("ship-collection");
			this.ship.center();
			this.ship.regY = 220;
			this.ship.y = 110;
		}
	};

	p.removeGarbage = function(garbage)
	{
		this.garbageCollector.removeChild(garbage);
	};

	p.rotatingGarbage = function()
	{
		var l = this.garbageCollector.numChildren;
		var fl = 1000;

		for (var i = l - 1; i >= 0; i--) {
			var bmp = this.garbageCollector.getChildAt(i);
			bmp.rotation += bmp.rt;
			var scale = fl / (fl + bmp.z);
			bmp._x += bmp.vx;
			bmp._y += bmp.vy;
			bmp.z -= bmp.vz * cm.main.speed * 0.5;
			// bmp.x = bmp._x * scale * 0.1;
			// bmp.y = bmp._y * scale * 0.1;
			bmp.scaleX = scale;
			bmp.scaleY = scale;
			bmp.rotation += bmp.rt;
		}
	};

	p._tick = function(e)
	{
		if(cm.main.pause){return;}
		this.rotatingGarbage();
		this.Container__tick(e);
	};

	cm.CollectionShip = cjs.promote(CollectionShip, "Container");
})();
